import { Check } from "lucide-react";

const DEFAULT_STEPS = ["Form", "Tiering", "Launch"];

interface IntakeReviewStepperProps {
  currentStep?: number;
  steps?: string[];
}

export function IntakeReviewStepper({
  currentStep = 1,
  steps = DEFAULT_STEPS,
}: IntakeReviewStepperProps) {
  return (
    <div className="flex flex-row items-center justify-center gap-6">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <div key={label} className="flex flex-row items-center gap-6">
            {/* Step circle with label */}
            <div className="flex flex-row items-center gap-3">
              <div
                className={`flex items-center justify-center w-6 h-6 rounded-full ${
                  isCompleted || isActive ? "bg-[#006FEE]" : "bg-[#F1F5F9]"
                }`}
              >
                {isCompleted ? (
                  <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                ) : (
                  <span
                    className={`text-xs font-medium leading-4 ${
                      isActive ? "text-white" : "text-[#62748E]"
                    }`}
                  >
                    {stepNumber}
                  </span>
                )}
              </div>
              <span className="text-xs font-semibold leading-4 whitespace-nowrap text-[#18181B]">
                {label}
              </span>
            </div>

            {/* Connecting line (except for last step) */}
            {index < steps.length - 1 && (
              <div className="w-9 h-0 border-t border-[#E2E8F0]" />
            )}
          </div>
        );
      })}
    </div>
  );
}
